export default __webpack_public_path__ + "static/media/c10.23e91495.png";